//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#00A769'
    }
  }
}
